"use client";

import { buttonVariants } from "@/components/fun-ui/Button"
import { cn } from "@/lib/utils"
import Image from "next/image";
import Link from "next/link"
import { usePathname } from "next/navigation";
import { publicAsset } from "@/lib/public-assets";

export default function PageNotFound() {
  const pathname = usePathname();
  if (pathname === '/qrcode') {
    return (
      <div className="flex flex-col h-screen w-screen items-center justify-center">
        <div className="h-1/2 flex-1 flex flex-col items-center justify-center">
          <Image alt="logo" width={120} height={120} src={publicAsset("/logo.svg")} />
          <div className="text-4xl font-semibold mt-8">FindinAI</div>
          <div className="text-muted-foreground text-2xl mt-3">10倍速你的学术研究效率</div>
        </div>
        <div className="h-1/2 flex-1 flex flex-col justify-start items-center pt-10">
          <div className="text-muted-foreground text-2xl">温馨提示</div>
          <div className="text-4xl font-semibold mt-3">请使用微信扫码</div>
        </div>

      </div>
    );
  }
  return (
    <div className="flex flex-col h-screen w-screen items-center justify-center">
      <Image alt="404" width={220} height={80} src="https://oss.findinai.cn/storage/20250118/48ead0a0759f36f9e45733662f9e711e.svg" />
      <div className="mt-6 text-annotation-foreground text-sm">
        诶呀，页面丢失了，返回首页吧！
      </div>
      <Link
        href="/"
        className={cn(
          buttonVariants({ variant: "default" }),
          "py-0 px-10 rounded-full cursor-pointer mt-10",
        )}
      >返回首页</Link>
    </div>
  )
}
